import React, { Fragment, useEffect, useState } from "react"
import { Box, Divider, Typography } from "@mui/material"
import Question from "./Question"
import styles from "../../PendingQuestionTable.module.scss"
import { useTheme } from "@mui/system"
import { Col, Row } from "react-bootstrap"
import ImageDisplay from "components/ImageDisplayer"
import WeeklyCategoryCard from "./weeklyCategoryCard"
import { useSelector } from "react-redux"

function WeeklyChallengeQuestions({ questions, questionCount }) {
  const theme = useTheme()

  const [questionCategoryCount, setQuestionCategoryCount] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("all")
  const [questionList, setQuestionsList] = useState([])
  const { isLoading } = useSelector((state) => state?.app)
  const allSelected = selectedCategory === "all"

  const style = {
    box: {
      borderRadius: "0",
      padding: "0",
      background: "none",
      paddingRight: "16px"
    },
    divider: {
      background: theme.palette.text.primary,
      height: "2px",
      opacity: 0.12
    }
  }

  useEffect(() => {
    if (questionCount?.length) {
      const categoryCount = [
        { title: "All", category: "all", count: questions?.length },
        ...questionCount.map((item) => ({
          title: item.category_name,
          category: item.category_id,
          count: item.question_count
        }))
      ]
      setQuestionCategoryCount(categoryCount)
    }
  }, [questionCount, questions])

  useEffect(() => {
    if (selectedCategory === "all") {
      setQuestionsList(questions)
    } else {
      const filtered = questions?.filter((q) => q.category_id === selectedCategory)
      setQuestionsList(filtered)
    }
  }, [selectedCategory, questions])

  return (
    <Fragment>
      {!!questions?.length && (
        <Row>
          <Col lg="12">
            <Box className="d-flex w-100 flex-wrap">
              {questionCategoryCount?.map((option, index) => (
                <WeeklyCategoryCard
                  key={index}
                  title={option?.title}
                  category={option?.category}
                  count={option?.count}
                  handleClick={() => setSelectedCategory(option?.category)}
                  isIncluded={
                    allSelected ? option?.category === "all" : selectedCategory === option?.category
                  }
                />
              ))}
            </Box>
          </Col>
        </Row>
      )}
      <Divider sx={style.divider} />
      {questionList?.length > 0 ? (
        questionList?.map((question, index) => (
          <Fragment key={question?.id}>
            <Box className={styles.questionViewCtr} sx={style.box}>
              <Question question={question} status={question?.status} index={index} />
              <div
                className={`p-2 d-flex align-items-center justify-content-end ${styles.imageContainer}`}>
                <ImageDisplay data={question?.image} style={{ width: "150px", height: "150px" }} />
              </div>
            </Box>
            {index !== questionList.length - 1 && <Divider sx={style.divider} />}
          </Fragment>
        ))
      ) : (
        <Box className="d-flex justify-content-center align-items-center" height={"60vh"}>
          <Typography variant="h2" className="d-flex justify-content-center">
            {isLoading ? "Please wait, we are fetching the questions..." : "No Questions Found"}
          </Typography>
        </Box>
      )}
    </Fragment>
  )
}

export default WeeklyChallengeQuestions
